module.exports = {
  getFieldType: (field) => field.typeText
    ?? field.typeSelect
    ?? field.typeDateTime
    ?? field.typeCheckbox
    ?? field.typeUpload,

  // `getRequiredField` used to append an asterisk here. Required is now the unmarked
  // default and the optional fields carry the marker instead — see `FieldLabel`.
};
